/**
 * INFORMACIÓN · «FORMA PARTE DE M SOCCER ACADEMY»
 * =============================================================================
 * La fotografía de los dos jugadores a pantalla completa, con el texto encima.
 * Debajo van las cuatro tarjetas y el botón de solicitar información.
 *
 * -----------------------------------------------------------------------------
 * LAS TARJETAS SON BOTONES DE VERDAD
 * -----------------------------------------------------------------------------
 *   · Escríbenos → lleva al formulario
 *   · Correo     → abre el cliente de correo con el asunto puesto
 *   · Ubicación  → abre Google Maps
 *   · Horarios   → baja a la sección de horarios
 *
 * En la referencia la primera tarjeta es de WhatsApp. Como pediste no ponerlo por
 * el momento, lleva al formulario en lugar de a un número inventado. En cuanto
 * pongas el número en `config.ts` y actives `whatsapp.activo`, se cambia sola.
 */

import { CONFIG, estaPendiente } from '../config';
import { useAjustes, enlaceWhatsApp } from '../i18n/useAjustes';
import { PantallaCompleta } from '../componentes/PantallaCompleta';
import { Icono, type NombreIcono } from '../componentes/Iconos';
import { Revelar } from '../componentes/Piezas';
import { useIdioma } from '../i18n/useIdioma';

export function Informacion() {
  const { textos } = useIdioma();
  const { valor, activo } = useAjustes();
  const t = textos.informacion;

  const irA = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  const abrirCorreo = () => {
    window.location.href = `mailto:${CONFIG.correo}?subject=${encodeURIComponent(
      t.asuntoCorreo
    )}`;
  };

  const abrirMapa = () => window.open(valor('contacto_mapa'), '_blank', 'noopener');

  /* El WhatsApp lo controla el panel: si esta apagado o sin numero, no sale. */
  const enlaceWA = enlaceWhatsApp(
    activo('whatsapp_activo'),
    valor('whatsapp_numero'),
    valor('whatsapp_mensaje')
  );
  const hayWhatsApp = enlaceWA !== null;

  const tarjetas: Array<{
    titulo: string;
    texto: string;
    icono: NombreIcono;
    alPulsar: () => void;
  }> = [
    {
      titulo: hayWhatsApp ? 'WhatsApp' : t.tarjetas[0]?.titulo ?? 'ESCRÍBENOS',
      texto: hayWhatsApp ? t.tarjetaEscribenos : t.tarjetas[0]?.texto ?? '',
      icono: 'sobre',
      alPulsar: () => {
        if (enlaceWA) {
          window.open(enlaceWA, '_blank', 'noopener');
        } else {
          irA('formulario');
        }
      },
    },
    {
      titulo: t.tarjetas[1]?.titulo ?? 'CORREO',
      texto: estaPendiente(valor('contacto_correo')) ? t.tarjetaSinCorreo : t.tarjetas[1]?.texto ?? '',
      icono: 'sobre',
      alPulsar: () => (estaPendiente(valor('contacto_correo')) ? irA('formulario') : abrirCorreo()),
    },
    {
      titulo: t.tarjetas[2]?.titulo ?? 'UBICACIÓN',
      texto: t.tarjetas[2]?.texto ?? '',
      icono: 'pin',
      alPulsar: abrirMapa,
    },
    {
      titulo: 'HORARIOS',
      texto: activo('horarios_confirmados') ? t.tarjetaHorarios : t.tarjetaHorariosPendiente,
      icono: 'calendario',
      alPulsar: () => irA('horarios'),
    },
  ];

  return (
    <>
      <PantallaCompleta
        id="informacion"
        foto={CONFIG.fotos.portadaInformacion}
        alt={t.fotoAlt}
        etiqueta={t.etiqueta}
        tituloMedio
        titulo={
          <>
            {t.titulo1} <span className="oro">{t.titulo2}</span>
            <br />
            {t.titulo3}
          </>
        }
        texto={t.texto}
        encuadre="50% 30%"
        encuadreMovil="50% 24%"
      />

      <div className="caja">
        <Revelar>
          <div className="tarjetas-contacto">
            {tarjetas.map((c) => (
              <button
                type="button"
                className="tarjeta-contacto"
                key={c.titulo}
                onClick={c.alPulsar}
              >
                <span className="aro" style={{ width: 54, height: 54 }}>
                  <Icono nombre={c.icono} tam={22} />
                </span>
                <span className="tarjeta-contacto__titulo">{c.titulo}</span>
                <span className="tarjeta-contacto__texto">{c.texto}</span>
              </button>
            ))}
          </div>
        </Revelar>

        <Revelar>
          <div className="acciones-fila">
            <button type="button" className="boton boton--oro" onClick={() => irA('formulario')}>
              <span>{t.boton}</span>
              <Icono nombre="flecha" tam={17} />
            </button>
          </div>
        </Revelar>
      </div>
    </>
  );
}
